export default __webpack_public_path__ + "static/media/project-work.fc46eca5.png";